import { NewContactType } from "types";
import { apiGet, apiPost, CRM_API_URI } from "../api";

const contact = {
    getAllByClientId: async (clientId: number) => {
        const data = apiGet(`${CRM_API_URI}/api/contact/manage?clientId=${clientId}`);
        return data;
    },
    save: async (contact: NewContactType) => {
        const data = await apiPost(`${CRM_API_URI}/api/contact?Name=${contact.Name}&Surname=${contact.Surname}&Email=${contact.Email}&Phone=${contact.Phone}`);
        return data;
    },
    setPassword: async (id: number, password: string) => {
        const data = await apiPost(`https://crm-api.amasocial.co.za/api/user/password/set`, {
            IDUser: id,
            Password: password,
            PasswordConfirm: password,
        });
        return data;
    },
    AddClientAndLinkClientContact: async (contact: any) => {
        const data = await apiPost(`${CRM_API_URI}/api/contact/save`, contact);
        return data;
    },
};

export default contact;
